import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { OperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/operation/operation.dto'

class OperationService {
    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<OperationResponse>> {
        const response = await axios.put<IResponseAgGrid<OperationResponse>>(`/configuration/operations`, { ...filterModel }, { params })
        return response.data
    }
    async getAllTaskSectionOperations(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<OperationResponse>> {
        const response = await axios.put<IResponseAgGrid<OperationResponse>>(`/configuration/operations/allTaskSectionOperations`, { ...filterModel }, { params })
        return response.data
    }
}

export const operationService = new OperationService()
